import { getMessages } from '../../../../../../../store/constants';

export const PREVIEW_HEADER_TITLE = getMessages().getText('preview.header.title');
export const PREVIEW_HEADER_CARDS_KEYS = ['preview.header.title.card', 'preview.header.title.cards'];
